import { render, staticRenderFns } from "./InvoiceItemEditor.vue?vue&type=template&id=be88fff0"
import script from "./InvoiceItemEditor.vue?vue&type=script&lang=js"
export * from "./InvoiceItemEditor.vue?vue&type=script&lang=js"
import style0 from "./InvoiceItemEditor.vue?vue&type=style&index=0&id=be88fff0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports